import React from 'react';

import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';

import {
    profileMain,
    profileMainContent,
    profileMainHeader,
} from './profile-main.module.styl';

type Props = {
    children: React.ReactNode,
    header?: React.ReactNode,
    footer?: React.ReactNode,
    stickToElement?: string,
};

export const ProfileMain = ({header, children, footer, stickToElement}: Props) => (
    <div className={profileMain}>
        {header ? (
            <StickyElement findStickToElement={!stickToElement} stickToElement={stickToElement}>
                <div className={profileMainHeader}>{header}</div>
            </StickyElement>
        ) : null}
        <div className={profileMainContent}>
            <Group direction="v" gap="xl">
                {children}
            </Group>
        </div>
        {footer}
    </div>
);
